import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { AuthUser } from "@/types";

export interface ImpersonationMeta {
  impersonatorToken: string;
  impersonatorRole: "family" | "admin";
  impersonatorUser: AuthUser;
  impersonatedUuid: string;
  impersonatedName: string;
}

export interface ImpersonationState {
  meta: ImpersonationMeta | null;
  start: (meta: ImpersonationMeta) => void;
  stop: () => void;
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      meta: null,
      start: (meta) => set({ meta }),
      stop: () => set({ meta: null }),
    }),
    {
      name: "impersonation-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
